import * as flowDesignerPreferencesActions from 'actions/flowDesignerPreferences';
import { StepListFilterType } from '@xmatters/common/constants/scriptSteps';

const {
  DISMISS_DRAG_HINT_PROPERTY_SIDE_PANEL,
  SET_HTTP_TRIGGER_LIST_FILTER_TYPE,
  SET_CUSTOM_STEP_LIST_FILTER_TYPE,
  SET_CALLABLE_FLOW_LIST_FILTER_TYPE,
} = flowDesignerPreferencesActions;

export const getInitialState = () => ({
  dismissDragHintOnPropertySidePanel: false,
  callableFlowListFilterType: StepListFilterType.ALL,
  customHttpTriggerListFilterType: StepListFilterType.ALL,
  customStepListFilterType: StepListFilterType.ALL,
});

export default function flowDesignerPreferences(
  state = getInitialState(),
  action,
) {
  const { type, payload } = action;
  switch (type) {
    case DISMISS_DRAG_HINT_PROPERTY_SIDE_PANEL: {
      return {
        ...state,
        dismissDragHintOnPropertySidePanel: true,
      };
    }
    case SET_CALLABLE_FLOW_LIST_FILTER_TYPE: {
      return {
        ...state,
        callableFlowListFilterType: payload,
      };
    }
    case SET_HTTP_TRIGGER_LIST_FILTER_TYPE: {
      return {
        ...state,
        customHttpTriggerListFilterType: payload,
      };
    }
    case SET_CUSTOM_STEP_LIST_FILTER_TYPE: {
      return {
        ...state,
        customStepListFilterType: payload,
      };
    }
    default:
      return state;
  }
}
